var app = angular.module("leonardo");

var TaskReportDialog = function($scope, $state, FilterService, ReportService, FormErrorsService, TaskService,
                                $rootScope, $timeout) {
  $scope.data = {
    incomplete: true,
    complete: true,
    cannot_do: true,
    completed_due: true,
    snoozed: false,
    property_reports: FilterService.getFilter('property')
  };
  $scope.status = [];
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.status = [];
    angular.forEach($scope.data, function(value, key) {
      switch (key) {
        case 'incomplete':
          if (value) {
            $scope.status.push(TaskService.STATUS_PENDING);
          }
          break;
        case 'complete':
          if (value) {
            $scope.status.push(TaskService.STATUS_SOLVED);
          }
          break;
        case 'cannot_do':
          if (value) {
            $scope.status.push(TaskService.STATUS_CANNOT_DO);
          }
          break;
        case 'completed_due':
          if(value){
            FilterService.setFilter('completed_on_due', '1');
          }
          break;
        case 'snoozed':
          if(value){
            FilterService.setFilter('snoozed', '1');
          }
          break;
        default: FilterService.setFilter(key, value, true);
      }
    });
    if ($scope.status.length > 0) {
      FilterService.setFilter('status', $scope.status);
    }
    ReportService.setQuickReport({filters: $scope.data});
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $timeout(function () {
      $state.go('reports.action-item');
    }, 100);
    $scope.closeThisDialog();
  };
};

app.controller('TaskReportDialog', ['$scope', '$state', 'FilterService', 'ReportService', 'FormErrorsService',
  'TaskService', '$rootScope', '$timeout', TaskReportDialog]);
